import { PhoneSetting } from './phone-number-mode';

export enum Endpoint {
  Identity = 'identity',
  Oauth = 'oauth',
}

export type DeploymentConfigBoolean = 'true' | 'false' | boolean;

export type DeploymentConfig = {
  [Endpoint.Identity]: string;
  [Endpoint.Oauth]: string;
  iproovEnabled?: DeploymentConfigBoolean;
  iproovOptOutAllowed?: DeploymentConfigBoolean;
  systemAdminEmail: string;
  externalFaq: string;
  externalTermsOfUse: string;
  externalPrivacyPolicy: string;
  phoneEnabled: PhoneSetting;
  additionalSetupPages?: DeploymentConfigBoolean;
  selfRegistrationEnabled?: DeploymentConfigBoolean;
}

/**
 * Interpret a deployment config value as a boolean.
 * @param value The config value, which may be optional
 * @returns True if the value is a true boolean or a string form of true
 */
export function fromBoolean(value: DeploymentConfigBoolean | undefined): boolean {
  return value === true || (typeof value === 'string' && value.trim().toLowerCase() === 'true');
}
